import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function ProtectedRoute({ Component, allowedRoles }) {
  const { isLoggedIn, userType } = useSelector((state) => ({
    isLoggedIn: state.auth.login,
    userType: state.auth.userType,
  }));
  console.log(isLoggedIn);
  console.log(userType);

  // Redirect if the user is not logged in
  if (!isLoggedIn) {
    return <Navigate to="/auth/login" />;
  }

  // Redirect if the user does not have the required role
  if (allowedRoles && !allowedRoles.includes(userType)) {
    // Special case for 'borrower' to redirect to '/manager'
    if (userType === 'borrower') {
      return <Navigate to="/manager" />;
    }
    // Default redirection for other unauthorized user types
    return <Navigate to={`/${userType}`} />;
  }

  return <Component />;
}

// PropTypes validation
ProtectedRoute.propTypes = {
  Component: PropTypes.elementType.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

ProtectedRoute.defaultProps = {
  allowedRoles: null, // Default to null if not provided
};

export default ProtectedRoute;
